//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        id: Number
    },

    data () {
        return {
            tableLoading: false,
            classroom: {},
            tableSorting: ''
        };
    },

    computed: {
        params: function () {
            let params = {};

            if (this.tableSorting !== '' && this.tableSorting !== 'null|asc') {
                params.sort = this.tableSorting;
            }

            return params;
        }
    },

    mounted () {
        this.loadData();
    },

    methods: {
        loadData () {
            this.tableLoading = true;

            axios.get(`classrooms/${this.id}/details`, {
                params: this.params
            }).then(response => {
                this.classroom = response.data;
            }).then(() => {
                this.tableLoading = false;
            }).catch(error => {
                console.log(error);
            });
        },
        handleTableSort (data) {
            let order = 'asc';

            if (data.order === 'descending') {
                order = 'desc';
            }
            console.log(data);
            this.tableSorting = data.prop + '|' + order;
            this.loadData();
        },
        getCurrentPlanet (pupil) {
            if (pupil.current_route === null) {
                return '-';
            }

            return this.$lang.get('dashboard.planets-finished.planets.week' + pupil.current_route[1]);
        }
    }
};
